import React from 'react';

interface LabelIconProps {
  url: string;
  alt: string;
  className?: string;
}

export function LabelIcon({ url, alt, className }: LabelIconProps) {
  return (
    <span
      className={className}
      role="img"
      aria-label={alt}
      style={{
        WebkitMaskImage: `url(${url})`,
        maskImage: `url(${url})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
        backgroundColor: 'currentColor',
      }}
    />
  );
}
